import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Typography, Paper, List } from '@mui/material';
import Loading from 'components/Loading';
import CategoryItem, { CategoryItemT } from './components/CategoryItem';

type CategoryT = {
    name: string;
    items: CategoryItemT[];
};

const StyCategoryContainer = styled('div', {
    name: 'StyCategoryContainer',
})({
    marginBottom: '3rem',
    '&:last-child': {
        marginBottom: '0rem',
    },
});

type Props = {
    items: CategoryT[];
    loading: boolean;
    selectedItemKey: string;
};

const SideList = ({
    items,
    loading,
    selectedItemKey,
}: Props): React.ReactElement => {
    const list = (
        <List>
            {items.map((category) => (
                <StyCategoryContainer key={category.name}>
                    <Typography
                        variant="h5"
                        sx={{ ml: '1.5rem', mb: '1rem' }}
                        gutterBottom
                    >
                        {category.name}
                    </Typography>

                    {category.items.map((item) => (
                        <CategoryItem
                            item={item}
                            key={item.value}
                            isSelected={selectedItemKey === item.value}
                        />
                    ))}
                </StyCategoryContainer>
            ))}
        </List>
    );

    const content = loading ? <Loading /> : list;

    return (
        <Paper
            sx={{
                minWidth: '260px',
                background: (theme) => theme.palette.lightGrey,
            }}
            elevation={0}
            square
        >
            {content}
        </Paper>
    );
};

export default SideList;
